import { appName, baseUrlWS } from "../app.json";

export const CleanMessage = (message) => message.replace("GraphQL error:", "").replace("Network error:", "");

export const cleanDate = (date, onlyDate = false, short = true) =>
    onlyDate
        ? Intl.DateTimeFormat("en-GB", {
              month: short ? "short" : "long",
              year: "numeric",
              weekday: short ? "short" : "long",
              day: "numeric",
          }).format(new Date(date))
        : Intl.DateTimeFormat("en-GB", {
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              hour12: false,
              month: short ? "short" : "long",
              year: "numeric",
              weekday: short ? "short" : "long",
              day: "numeric",
          }).format(new Date(date));

export const AppName = appName;

export const WSS_URL = baseUrlWS;

export const CleanNumber = (number) => Intl.NumberFormat("en-GB").format(number);
